<template>
    <dash
        icon="fa fa-dollar"
        titulo="PAGAMENTOS SGF"
        subTitulo="UFI"
        @click.native="$router.push({ name: 'Uabs_Finalizacoes' })"
        :qtd="qtd"
        :qtd2="qtd2"
        :mostrarQtd="true"
        :mostrarQtd2="true"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        qtd: {
            type: Number
        },
        
        qtd2: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
